module.exports = __webpack_public_path__ + "static/img/dd-chart.ecb60af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dd/dd-chart.png
// module id = A7sw
// module chunks = 1